import { render, staticRenderFns } from "./default-promoted.vue?vue&type=template&id=357631fa&"
import script from "./default-promoted.vue?vue&type=script&lang=ts&"
export * from "./default-promoted.vue?vue&type=script&lang=ts&"
import style0 from "./default-promoted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports